import SimpleAccordion from '../../../Core/Expansion/SimpleAccordion'
import React from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import {ModificationContextStore,POLICY_MODIFICATION_CONTEXT_ACTIONS} from '../../../../context/ModificationContext'
import { PolicyDroneView } from '../../../Core/Hull/PolicyDroneView'
import { PolicyEquipmentView } from '../../../Core/Hull/PolicyEquipmentView'
import { HullPopover } from '../../../Core/Popover/HullPopover'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import { CustomizeDroneModify } from './CustomizeDroneModify';
import './ModifyHullSection.scss';
import { isMobile } from 'react-device-detect'
import { Divider } from '@material-ui/core'
import { CustomizeEquipmentModify } from './CustomizeEquipmentModify'
import ViolationsService from '../../../../services/ViolationsService'
import { Action } from '../../../../models/Action'
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService'
import { InsuranceBillingPeriod } from '../../../../models/insurance-models/InsuranceBillingPeriodModel'
import { DroneModifyView } from './DroneModifyView'
import { EquipmentModifyView } from './EquipmentModifyView'
import { SessionService } from '../../../../services/SessionService'
import { SessionContextStore } from '../../../../context/SessionContext'

interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}

export const ModifyHullSection = ({...props}) => {
    const sessionContext = React.useContext(SessionContextStore)
    const modificationContext = React.useContext(ModificationContextStore) 
    const [error, setError] = React.useState()
    const defaultDeductibleRate = (FirebaseService.getValue(!!modificationContext.subscription.billingPeriod && modificationContext.subscription.billingPeriod.startsWith(InsuranceBillingPeriod.MONTH)? FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR : FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR_ANNUAL) * 100).toFixed(0)

    const defaults = {
        make: "",
        model: "",
        serial: "",
        type: "",
        is_rented: false,
        id: "",
        deductibleRate:defaultDeductibleRate,
        end_date: modificationContext.subscription.nextPolicyDate,
        start_date: new Date()
    }
    const [defaultValues, setDefaultValues] = React.useState(defaults)
    const initialMode = {
        isDroneSetMode: false,
        isEquipmentSetMode: false,
        add: false,
        modify: false,
        delete: false,
        index: -1
    }
    const [modes, setModes] = React.useState(initialMode)
    const {insurance, isOpen, modificationObject, isRenewal} = props;

    const prettyHull = () => {
        let dronesAndEquipment = ''
        modificationObject.drones.map(drone =>{
            dronesAndEquipment += `${drone.make}: ${drone.model} `
        })
        modificationObject.equipment.map(equipment =>{
            dronesAndEquipment += `${equipment.type}: ${equipment.description} `
        })
        return dronesAndEquipment;
    }

    const addDrone = () => {
        setModes({...modes, isDroneSetMode: true, isEquipmentSetMode:false, add: true, modify:false, delete:false})
    }

    const editDrone = (index, drone) => {
        setModes({...modes, isDroneSetMode: true, isEquipmentSetMode:false, add: false, modify:true, delete:false, index: index})
        setDefaultValues({...defaults, make: drone.make, model: drone.model, serial: drone.serial, value: drone.value, id: drone.id, deductibleRate: drone.deductibleRate, end_date: drone.end_date, start_date: drone.start_date})
    }

    const deleteDrone = (index) => {
        modificationContext.deleteItem(index, 'drone',isRenewal)
    }

    const addEquipment = () => {
        setModes({...modes, isDroneSetMode: false, isEquipmentSetMode:true, add: true, modify:false, delete:false})
        setDefaultValues(defaults)
    }

    const editEquipment = (index, equipment) => {
        setModes({...modes, isDroneSetMode: false, isEquipmentSetMode:true, add: false, modify:true, delete:false, index: index})
        setDefaultValues({...defaults, description: equipment.description, serial: equipment.serial, value: equipment.value, quantity: equipment.quantity, is_rented: equipment.isRented ? equipment.isRented : false, type: equipment.type, id: equipment.id, deductibleRate: equipment.deductibleRate})
    }

    const deleteEquipment = (index) => {
        modificationContext.deleteItem(index, 'equipment',isRenewal)
    }
    const allowedToChangeHull = () => {
        if(SessionService.isAdmin()) return true;

        const res = !sessionContext.user.hullEligibility || modificationObject.drones.some(drone =>  drone.deductibleRate != defaultDeductibleRate) 
        || modificationObject.equipment.some(equipment =>  equipment.deductibleRate != defaultDeductibleRate)

        return !res
    }

    React.useEffect(() => {
        let violations = ViolationsService.checkHullViolations(modificationObject, modificationObject.drones, modificationObject.equipment)
        if(violations.error) {
            setError(violations.msg)
            modificationContext.dispatch(new Action(POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_HULL_SECTION_VALID, false))
        }
        else {
            setError('')
            modificationContext.dispatch(new Action(POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_HULL_SECTION_VALID, true))
        }
    }, [modificationObject.drones, modificationObject.equipment, modificationObject.liabilityLimit])
 

    return (
    <React.Fragment>
       <SimpleAccordion className='margin-top-large' 
       title={
       <FlexView column className="space-between full-width"> <div>Edit Physical Damage Coverage (Hull) <HullPopover /></div>
            
            {/* <div className="grey text-small">{prettyHull()}</div> */}
       </FlexView>} 
            content={
                <div>
                {<>
                {modificationObject.drones.map((drone, index) => 
                <div key={index} className="margin-top-basic">
                  <FlexView className="space-between">
                        <DroneModifyView  drone={drone} defaultDeductibleRate={defaultDeductibleRate}/>  
                       <div className="margin-top-basic icons-right">
                       {allowedToChangeHull() && (((SessionService.isAdmin() || isRenewal) && drone.endDate === undefined ) || !drone.id) && <EditIcon className="tiny-icon clickable" color="primary" onClick={() => editDrone(index, drone)}/>}
                       {allowedToChangeHull() && (((SessionService.isAdmin() || isRenewal)  && drone.endDate === undefined) || !drone.id) && <DeleteIcon className="tiny-icon clickable" color="primary" onClick={() => deleteDrone(index)} />}
                        </div>
                  </FlexView>
                  {isMobile && <Divider/>}
                  </div>)}
                {modificationObject.equipment.map((equipment, index) => 
                <div key={index} className="margin-top-basic">
                <FlexView className="space-between">
                        <EquipmentModifyView  equipment={equipment} defaultDeductibleRate={defaultDeductibleRate}/>
                       <div className="margin-top-basic icons-right">
                       {allowedToChangeHull() && (((SessionService.isAdmin() &&  equipment.endDate === undefined) || isRenewal) || !equipment.id) && <EditIcon className="tiny-icon clickable" color="primary" onClick={() => editEquipment(index, equipment)}/>}
                       {allowedToChangeHull() && ((SessionService.isAdmin() || isRenewal) || !equipment.id) && <DeleteIcon className="tiny-icon clickable" color="primary" onClick={() => deleteEquipment(index)} />}
                        </div>
                  </FlexView>
                  {isMobile && <Divider/>}
                  </div>)}
                  
                <FlexView className="margin-top-medium margin-bottom-medium">
                    {allowedToChangeHull() && <div onClick={addDrone}                             
                    className="text-small textcenter blue bold clickable margin-right-basic">+ Add drone</div>}
                    {allowedToChangeHull() && <div onClick={addEquipment} className="text-small textcenter blue bold clickable margin-left-basic">+ Add equipment</div>} 
                </FlexView>
                <FlexView>
                {!!error && error}
                </FlexView>
                { modes.isDroneSetMode &&
                        <>
                        <CloseIcon className="tiny-icon clickable textright margin-bottom-basic margin-right-basic" color="primary" onClick={() => setModes({...modes, isDroneSetMode: false, add: false, modify:false})}  />
                        <CustomizeDroneModify endDate={modificationContext.subscription.nextPolicyDate} defaultValues={defaultValues} mode={modes} isRenewal={isRenewal} showFields={() => setModes({...modes, isDroneSetMode:false})} />
                        </>
                }
                {
                    modes.isEquipmentSetMode &&
                    <>
                    <CloseIcon className="tiny-icon clickable textright margin-bottom-basic margin-right-basic" color="primary" onClick={() => setModes({...modes, isEquipmentSetMode:false, add: false, modify:false})} />
                    <CustomizeEquipmentModify defaultValues={defaultValues} isRenewal={isRenewal} modificationObject={modificationObject} mode={modes} showFields={() => setModes({...modes, isEquipmentSetMode:false})} />
                    </>
                }
                </>}
                </div>
                }/>
                
    </React.Fragment>)
}